import { GetAsinMetadataInput, useGetAsinMetadataQuery, AsinMetadataEntry } from '@graphql/generated/graphql';

const useGetAsinMetadataResults = (input: GetAsinMetadataInput) => {
  const { ...restInput }: GetAsinMetadataInput = input;

  const { data, isSuccess } = useGetAsinMetadataQuery({
    input: {
      ...restInput,
    },
  });
  const asinMetadataList: AsinMetadataEntry[] | undefined | null = data?.getAsinMetadata.asinMetadata;

  return {
    asinMetadataList,
    isSuccess,
  };
};

export default useGetAsinMetadataResults;
